
import graphemeLength from '@/lib/graphemeLength';

export default {
  name: 'AppTextareaLegacy',
  props: {
    id: { type: String, required: true },
    name: { type: String, required: true },
    value: { type: String, default: '' },
    placeholder: { type: String, required: true },
    maxlength: { type: Number, required: true },
    rows: { type: Number, required: true }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  computed: {
    valueLength() {
      return graphemeLength(this.currentValue);
    }
  },
  watch: {
    value() {
      this.currentValue = this.value;
    },
    currentValue() {
      this.$nextTick(this.resize);
    }
  },
  mounted() {
    this.resize();
  },
  methods: {
    onInput(newValue) {
      this.change(newValue);
    },
    change(newValue) {
      if (this.currentValue === newValue) return;

      this.currentValue = newValue;
      this.$emit('change', this.currentValue);
    },
    onBlur() {
      const newValue = this.currentValue.trim();
      if (this.currentValue !== newValue) this.change(newValue);
    },
    resize() {
      const BORDER_HEIGHT = 2;
      const textarea = this.$refs.textarea;

      textarea.style.setProperty('height', 'auto');
      const oldRows = textarea.rows;
      textarea.rows = this.rows;
      textarea.style.setProperty(
        'height',
        `${textarea.scrollHeight + BORDER_HEIGHT}px`
      );
      textarea.rows = oldRows;
    }
  }
};
